module.exports = __webpack_public_path__ + "static/media/rpsale_question.f3f9aa1a.mp3";